export var SKILL_REPOSITORY = 'SKILL_REPOSITORY';